// Copyright (c) StrangeBee 2024

import { ObservableOutput } from 'thehive-sdk';

export const splitObservable = (observable: string): string[] => {
    return Array.from(
        new Set( // to avoid duplicates
            observable
                .split('\n') // we create an entry for each line
                .reduce((acc, value) => {
                    const trimmedValue = value.trim();
                    if (trimmedValue !== '') {
                        return [...acc, trimmedValue];
                    }
                    return acc;
                }, [] as string[]), // we trim each line and we remove empty lines
        ),
    );
};

export const isAlreadyFang = (str: string) => /(\[\.\]|hxxp)/gi.test(str);

export const fang = (value: string): string =>
    value
        .replace(/\[\.\]/g, '.')
        .replace(/\./g, '[.]')
        .replace(/http:\/\//gi, 'hxxp://')
        .replace(/https:\/\//gi, 'hxxps://');

export const formatObservableTitle = ({ data, attachment }: Partial<ObservableOutput>): string =>
    fang(data || attachment?.name || '');
